import React, { useEffect } from 'react';
import { HashRouter, Route, Switch, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import Navbar from '../components/Navbar/Navbar';
import Home from '../screens/Home/Home';
import Contacts from '../screens/Contacts/Contacts';
import CallForSpeakers from '../screens/CallForSpeakers/CallForSpeakers';
import SpeakersContainer from '../screens/Speakers/Speakers';
import SpeakerDetailsContainer from '../screens/SpeakerDetails/SpeakerDetails';
import ProgramContainer from '../screens/Program/Program';
import TalkDetailContainer from '../screens/TalkDetail/TalkDetail';
import FeedbackForm from '../screens/FeedbackForm/FeedbackForm';

export const Routes = () => {
  const location = useLocation();

  useEffect(() => {
    if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
      ReactGA.initialize('UA-178637127-1');
      ReactGA.set({ anonymizeIp: true });
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [location]);

  return (
    <Route>
      <Navbar />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Home} exact path="/index.html" />
        <Route component={Contacts} exact path="/contacts" />
        <Route component={CallForSpeakers} exact path="/cfs" />
        <Route component={SpeakersContainer} exact path="/speakers" />
        <Route component={SpeakerDetailsContainer} exact path="/speakers/:speakerId" />
        <Route component={ProgramContainer} exact path="/program" />
        <Route component={TalkDetailContainer} exact path="/program/:talkId" />
        <Route component={ProgramContainer} exact path="/workshops" />
        <Route component={FeedbackForm} exact path="/ff" />
      </Switch>
    </Route>
  );
};

const RouterContainer = props => (
  <HashRouter {...props}>
    <Routes />
  </HashRouter>
);

export default RouterContainer;
